/* MojaPizza - gumb "Nalozi vec" namesto strani 1, 2, 3 na straneh kolekcij */
const LABEL = "Naloži več izdelkov";
const LOADING = "Nalagam ...";

const enhance = (pagination) => {
    if (pagination.dataset.loadMore) return;
    const results = document.querySelector(".js-results");
    const nextLink = pagination.querySelector(".next a");
    if (!results || !nextLink) return;
    pagination.dataset.loadMore = "true";

    const numbers = pagination.querySelector(".pagination");
    if (numbers) numbers.hidden = true;

    const button = document.createElement("button");
    button.type = "button";
    button.className = "c-btn c-btn--hollow collection-load-more";
    button.textContent = LABEL;
    button.dataset.nextUrl = nextLink.href;
    pagination.appendChild(button);

    button.addEventListener("click", async () => {
        const url = button.dataset.nextUrl;
        if (!url) return;
        button.disabled = true;
        button.textContent = LOADING;
        try {
            const html = await fetch(url).then((r) => r.text());
            const doc = new DOMParser().parseFromString(html, "text/html");
            const newItems = doc.querySelectorAll(".js-results > .o-layout__item");
            newItems.forEach((item) => results.appendChild(document.adoptNode(item)));
            const newNext = doc.querySelector(".js-pagination .next a");
            if (newNext) {
                button.dataset.nextUrl = newNext.href;
                button.disabled = false;
                button.textContent = LABEL;
            } else {
                button.remove();
            }
        } catch (e) {
            window.location.href = url;
        }
    });
};

const init = () => document.querySelectorAll(".js-pagination").forEach(enhance);

init();
const root = document.querySelector("dynamic-product-search") || document.body;
new MutationObserver(init).observe(root, { childList: true, subtree: true });
